import React, { useState } from "react";
import "./styles.css";
import { Link, useNavigate, useParams } from "react-router-dom";
import { FaArrowCircleLeft, FaEye } from "react-icons/fa";
import LogotipoRadaria from "../../assets/images/logotipos/RADARIA-LOGOTIPO04.png";
import { validateFormResetPwd } from "./validateFormResetPwd";
import { resetPassword } from "../../services/rest/users/resertPassword";
import toast from "react-hot-toast";
import handleErrorAPI from "../../utils/handleErrorAPI";
import Loading from "../../components/Loading/Loading";

const ResetPassword = () => {
  const { token } = useParams();
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [formValues, setFormValues] = useState({
    password: "",
    newPassword: "",
  });
  const navigate = useNavigate();
  const handleChange = (e) => {
    const { name, value } = e.target;
    delete errors[name];
    setFormValues({ ...formValues, [name]: value });
    errors.notMatch && delete errors.notMatch;
  };

  const handleSubmit = async (e) => {
    try {
      e.preventDefault();
      setLoading(true);
      const validationErrors = validateFormResetPwd(formValues);
      if (Object.keys(validationErrors).length > 0) {
        setErrors(validationErrors);
        setLoading(false);
        return;
      }
      const response = await resetPassword({ userData: formValues, token });
      setLoading(false);
      navigate("/auth");
      toast.success(`Se actualizó con exito su contraseña`, {
        duration: 10000,
      });
    } catch (error) {
      setLoading(false);
      const { message } = handleErrorAPI(error);
      toast.error(message, { duration: 10000 });
    }
  };

  return (
    <div className="wrapper-forgotPassword">
      <Loading loading={loading} />
      <section className="wrapper-form">
        <div className="d-flex justify-content-between align-items-center">
          <Link
            to="/auth"
            className="d-flex gap-3 justify-content-between align-items-center"
          >
            <FaArrowCircleLeft className="text-white fs-1" />
            <img src={LogotipoRadaria} alt="" width={200} height={40} />
          </Link>
        </div>
        <div className="form-wrapper">
          <h2 className="text-white text-center">Reestablecer Contraseña</h2>
          <form
            className="d-flex flex-column align-items-center justify-content-center "
            onSubmit={handleSubmit}
          >
            <section className="inputs-container">
              <div>
                <label
                  className={` form-label ${
                    errors.password ? "text-danger" : "text-white"
                  }`}
                >
                  {errors.password ? errors.password : "Nueva Contraseña:"}
                </label>
                <div className="input-group">
                  <input
                    type={showPassword ? "text" : "password"}
                    name="password"
                    value={formValues.password}
                    onChange={handleChange}
                    className={`form-control ${
                      errors.password && "is-invalid input-error"
                    } text-light`}
                    id="inputPasswordReset"
                    placeholder="Ingrese su contraseña"
                    aria-label="Recipient username"
                    aria-describedby="button-addon2"
                  />

                  <button
                    className={`btn btn-outline-primary ${
                      errors.password
                        ? "btn-outline-danger"
                        : "btn-outline-primary "
                    }`}
                    type="button"
                    id="button-addon2"
                    onClick={() => setShowPassword(!showPassword)}
                  >
                    <FaEye />
                  </button>
                </div>
              </div>
              <div>
                <label
                  className={` form-label ${
                    errors.newPassword ? "text-danger" : "text-white"
                  }`}
                >
                  {errors.newPassword
                    ? errors.newPassword
                    : " Confirmar Contraseña:"}
                </label>
                <div className="input-group">
                  <input
                    type={showConfirmPassword ? "text" : "password"}
                    name="newPassword"
                    value={formValues.newPassword}
                    onChange={handleChange}
                    className={`form-control ${
                      errors.newPassword && "is-invalid input-error"
                    } text-light`}
                    id="inputConfirmPassword"
                    placeholder="Confirmar contraseña"
                    aria-label="Recipient's username"
                    aria-describedby="button-addon2"
                  />
                  <button
                    className={`btn ${
                      errors.newPassword
                        ? "btn-outline-danger"
                        : "btn-outline-primary "
                    }`}
                    type="button"
                    id="button-addon2"
                    onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                  >
                    <FaEye />
                  </button>
                </div>
              </div>
            </section>

            {errors.notMatch && (
              <span
                className={`text-danger mt-3 ${
                  errors.notMatch ? "d-flex" : "d-none"
                }`}
              >
                {errors.notMatch}
              </span>
            )}

            <button type="submit" className="btn btn-primary mt-3">
              Restablecer
            </button>
          </form>
        </div>
      </section>
    </div>
  );
};

export default ResetPassword;
